<template>
  <div>
    <vx-card :title="data.titleId">

    </vx-card>
  </div>

</template>

<script>
  import draggable from 'vuedraggable'
  import _ from 'lodash'
  export default {
    props: {
      data: {
        type: Object,
        default: () => ({
          id: '',
          status: '',
          titleId: '',
          titleEn: '',
          subtitleId: '',
          subtitleEn: '',
          itemList: []
        })
      }
    },
    components: { draggable },
    methods: {
      onSelect(val) {
        this.data.itemList.push(
          _.pick(val, [
            'name',
            'logoUrl',
            'thumbnailUrl',
            'category',
            'email',
            'phone',
            'address'
          ]))

        this.saveChanges()
      },
      saveChanges () {
        this.$store.dispatch('recommendationBusiness/set', this.data)
      },
      remove (index) {
        this.data.itemList.splice(index, 1)
        this.saveChanges()
      }
    }
  }
</script>
